import React from 'react';
import { Menu, Container, Button, Icon } from 'semantic-ui-react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Navbar() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch {
      console.error('Failed to log out');
    }
  };

  return (
    <Menu fixed="top" inverted>
      <Container>
        <Menu.Item header>
          <img src="logoAnimateYouIcon_white.svg" alt="Animate Your Icon" />
          &nbsp;&nbsp;<span>Animate Your Icon</span>
        </Menu.Item>
        {currentUser ? (
          <Menu.Menu position="right">
            <Menu.Item>
              <Link to="/dashboard">
                <Icon name="dashboard" />
                Dashboard
              </Link>
            </Menu.Item>
            <Menu.Item>
              <Button onClick={handleLogout} inverted color="red">
                <Icon name="log out" />
                Log Out
              </Button>
            </Menu.Item>
          </Menu.Menu>
        ) : (
          <Menu.Menu position="right">
            <Menu.Item>
              <Link to="/login">
                <Button inverted color="blue">
                  <Icon name="sign-in" />
                  Log In
                </Button>
              </Link>
            </Menu.Item>
            <Menu.Item>
              <Link to="/signup">
                <Button inverted primary>
                  <Icon name="signup" />
                  Sign Up
                </Button>
              </Link>
            </Menu.Item>
          </Menu.Menu>
        )}
      </Container>
    </Menu>
  );
}
